<template>
  <div class="bg-white my-4 p-3 w-full">
    <div class="flex flex-col w-full">
      <h2 class="text-2xl font-bold mb-5">{{ farmer.name }}</h2>

      <div class="flex flex-wrap">
        <div class="m-1">
          <p v-if="farmer.address_line_1">{{ farmer.address_line_1 }},</p>
          <p v-if="farmer.address_line_2">{{ farmer.address_line_2 }},</p>
          <p v-if="farmer.city">{{ farmer.city }},</p>
          <p v-if="farmer.county">{{ farmer.county }},</p>
          <p v-if="farmer.eircode">
            {{ farmer.eircode }}
          </p>
        </div>

        <div class="m-1">
          <div class="mb-3" v-if="farmer.email">
            <strong>Email: </strong> {{ farmer.email }}
          </div>
          <div v-if="farmer.mobile">
            <strong>Phone:</strong> {{ farmer.mobile }}
          </div>
          <div class="mb-3" v-if="farmer.organisation">
            <strong>Organisation:</strong> {{ farmer.organisation }}
          </div>
          <div v-if="farmer.herd_no">
            <strong>Herd No:</strong> {{ farmer.herd_no }}
          </div>

          <div class="mb-3" v-if="farmer?.consultant_user">
            <strong>Consultant:</strong>
            {{
              farmer.consultant_user.first_name +
              " " +
              farmer.consultant_user.last_name
            }}
          </div>

          <div class="mb-2" v-if="farmer.account_number">
            <strong>Account Number: </strong> {{ farmer.account_number }}
          </div>
        </div>
      </div>
      <div class="flex flex-row mt-10 gap-10">
        <div>
          <h3 class="text-xs">Active</h3>
          <span class="text-lg font-bold">{{ farmer.enabled }}</span>
        </div>
        <div>
          <h3 class="text-xs">Derogation</h3>
          <span class="text-lg font-bold">{{ farmer.derogation }}</span>
        </div>
        <div>
          <h3 class="text-xs">Organic</h3>
          <span class="text-lg font-bold" v-if="farmer.organic == 0">{{
            "No"
          }}</span>
          <span class="text-lg font-bold" v-if="farmer.organic == 1">{{
            "Yes"
          }}</span>
          <span class="text-lg font-bold" v-if="farmer.organic == null">{{
            "Not Set"
          }}</span>
        </div>
      </div>
    </div>

    <div class="flex justify-start mt-4">
      <inertia-link
        class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        :href="route('app.farmer.edit', farmer.id)"
      >
        Edit farmer
      </inertia-link>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    farmer: Object,
  },
};
</script>
